export default __webpack_public_path__ + "static/media/98.bd7df220.png";